// extracted by mini-css-extract-plugin
module.exports = {"link":"style-module--link--n6ErM"};